import { SceneLoader } from '@babylonjs/core';
import '@babylonjs/loaders/glTF';
/**
 * 尝试加载 .glb 模型，失败返回 null（调用方自行降级到几何体）
 * 先用 HEAD 请求检查文件是否存在，避免控制台404噪音
 */
export async function loadModel(scene, path) {
    try {
        // 先检查文件是否存在
        const resp = await fetch(path, { method: 'HEAD' });
        if (!resp.ok)
            return null; // 文件不存在，静默返回
        const result = await SceneLoader.ImportMeshAsync('', path, '', scene);
        const root = result.meshes[0];
        const animations = new Map();
        for (const ag of result.animationGroups) {
            animations.set(ag.name.toLowerCase(), ag);
            ag.stop();
        }
        return {
            root,
            meshes: result.meshes,
            skeleton: result.skeletons?.[0] || null,
            animations,
        };
    }
    catch (e) {
        // 只在非404错误时打印警告
        console.warn(`[ModelLoader] 加载模型失败 ${path}`, e);
        return null;
    }
}
/**
 * 播放动画组（停止其它动画后播放指定的）
 */
export function playAnimation(animations, name, loop = true) {
    animations.forEach((ag, key) => {
        if (key === name.toLowerCase()) {
            if (!ag.isPlaying) {
                ag.start(loop);
            }
        }
        else {
            ag.stop();
        }
    });
}
